import { render, staticRenderFns } from "./ErrorModalBase.vue?vue&type=template&id=00f80430&scoped=true"
import script from "./ErrorModalBase.vue?vue&type=script&lang=js"
export * from "./ErrorModalBase.vue?vue&type=script&lang=js"
import style0 from "./ErrorModalBase.vue?vue&type=style&index=0&id=00f80430&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f80430",
  null
  
)

export default component.exports